// extracted by mini-css-extract-plugin
export default {"root":"IconClock_root__aq+xD"};